<template>
  <div style="width: 100%">
    <table class="ui striped selectable table">
      <thead>
        <tr>
          <th>#</th>
          <th>Roll number</th>
          <th>Name</th>
          <th>Number of Students</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!schools || schools.length == 0">
          <td></td>
          <td colspan="4">No schools found</td>
        </tr>
        <school-table-row
          v-for="school in schools"
          v-bind:school="school"
          v-bind:key="school.Id"
          v-bind:actions="actions"
          v-on:action="rowAction"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import SchoolTableRow from '@/components/schools/SchoolTableRow';

export default {
  name: 'SchoolTable',
  computed: {
    studentList() {
      return this.schools || null;
    },
  },
  components: { SchoolTableRow },
  props: ['schools', 'actions'],
  methods: {
    rowAction(action) {
      this.$emit('rowAction', action);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/schools/SchoolTable.vue